import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DebitNoteReducer } from '../reducers';

export const debitNoteFeature = createFeatureSelector<DebitNoteReducer.DataState>(DebitNoteReducer.featureName);

export const selectDebitNote = createSelector(debitNoteFeature, (state: DebitNoteReducer.DataState) => state.item);
